const reportsCockpit = require('./reportsCockipit.docx');

export { reportsCockpit };